import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Dropdown, Menu, Pagination, Table } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";
import LinkComponent from "../../components/layout/LinkComponent";
// import {useHistory} from "react-router-dom";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

const UserManage = () => {
	// const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [userCount, setUserCount] = useState(0);
	const [members, setMembers] = useState([]);

	const [pageSize, setPageSize] = useState(10);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);

	const [mediaResult, setMediaResult] = useState(null);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	const convertAge = (item) => {
		if (item) {
			const age = moment().diff(moment(item).format("YYYYMMDD"), "years");
			if (age > 9) {
				return Math.floor(age / 10) * 10 + "대";
			} else {
				return "10세 미만";
			}
		} else {
			return "알수없음";
		}
	};

	const pageSizeList = [
		{
			label: "10개씩",
			value: 10,
		},
		{
			label: "20개씩",
			value: 20,
		},
		{
			label: "30개씩",
			value: 30,
		},
		{
			label: "50개씩",
			value: 50,
		},
	];

	const dropdownPageSize = (
		<Menu>
			{pageSizeList?.map((item, idx) => (
				<Menu.Item
					key={`page-size-${idx}`}
					onClick={() => setPageSize(item.value)}
				>
					{item.label}
				</Menu.Item>
			))}
		</Menu>
	);

	const columns = mediaResult
		? [
				{
					title: "",
					dataIndex: "",
					key: "title",
					width: "100%",
					ellipsis: true,
					align: "left",
					render: (value) => {
						return (
							<div
								className={`analysis-mobile-div`}
								style={{ flexDirection: "row", gap: "3%" }}
							>
								<div
									className={`dashboard-members-each`}
									style={{
										gap: "7px",
										width: "40%",
									}}
								>
									<img
										src={
											value?.page_name === "dyApp"
												? value?.profile_img_type
													? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${value?.id}-${value?.profile_url}.${value?.profile_img_type}`
													: `/assets/images/channel/basic.png`
												: value?.profile_img_type
												? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${value?.id}.${value?.profile_img_type}`
												: `/assets/images/channel/basic.png`
										}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null; // prevents looping
											// currentTarget.style.display = "none";
											currentTarget.src = `/assets/images/channel/basic.png`;
										}}
										alt={`채널 이미지`}
										style={{
											width: "2em",
											height: "2em",
										}}
									/>
									<b
										style={{
											whiteSpace: "pre-wrap",
											wordBreak: "break-all",
										}}
									>
										{value?.nickname}
									</b>
								</div>
								<div
									className={`analysis-data-mobile-div`}
									style={{
										width: "57%",
									}}
								>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											gap: "3px",
										}}
									>
										<p>
											가입일자 ·{" "}
											{moment(value.created_at).format("YYYY년 MM월 DD일")}
										</p>
										<p>
											성별 ·{" "}
											{value?.gender === 1
												? "여성"
												: value?.gender === 2
												? "남성"
												: "알수없음"}
										</p>
										<p>연령대 · {convertAge(value?.birthday)}</p>
									</div>
								</div>
							</div>
						);
					},
				},
		  ]
		: [
				{
					title: "닉네임",
					dataIndex: "",
					key: "nickname",
					ellipsis: true,
					width: "40%",
					render: (value) => {
						return (
							<div className={`dashboard-members-each`}>
								<img
									src={
										value?.page_name === "dyApp"
											? value?.profile_img_type
												? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${value?.id}-${value?.profile_url}.${value?.profile_img_type}`
												: `/assets/images/channel/basic.png`
											: value?.profile_img_type
											? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${value?.id}.${value?.profile_img_type}`
											: `/assets/images/channel/basic.png`
									}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null; // prevents looping
										// currentTarget.style.display = "none";
										currentTarget.src = `/assets/images/channel/basic.png`;
									}}
									alt={`채널 이미지`}
									style={{
										width: "3em",
										height: "3em",
									}}
								/>
								<b>{value?.nickname}</b>
							</div>
						);
					},
				},
				{
					title: "가입 일자",
					dataIndex: "created_at",
					key: "created_at",
					ellipsis: true,
					width: "30%",
					render: (value) => {
						return (
							<span>{moment(value).format("YYYY년 MM월 DD일 a h시 m분")}</span>
							// <span>{moment(value).format("YYYY년 MM월 DD일 a h시 m분")}</span>
						);
					},
				},
				{
					title: "성별",
					dataIndex: "gender",
					key: "gender",
					ellipsis: true,
					width: "15%",
					render: (value) => {
						return (
							<span>
								{value === 1 ? "남성" : value === 2 ? "여성" : "알수없음"}
							</span>
						);
					},
				},
				{
					title: "연령대",
					dataIndex: "birthday",
					key: "birthday",
					ellipsis: true,
					width: "15%",
					render: (value) => {
						return <span>{convertAge(value)}</span>;
					},
				},
		  ];

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		if (user?.id) {
			getSignUpMembers();
		}
	}, [user, currentPageNumber, pageSize]);

	/**
	 * 회원가입 멤버 보여주기
	 * @type {(function(): Promise<void>)|*}
	 */
	const getSignUpMembers = useCallback(async () => {
		setIsLoading(true);
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const params = {
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.readSignUpMembers(param);
		// const rsp = await partnersApi.readSignUpUserCount(params);
		if (res.code === 200) {
			setUserCount(res.result?.userCount);
			setMembers(res.result.userList);
		}
		setIsLoading(false);
	}, [currentPageNumber, pageSize]);

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				{/*{isLoading && (*/}
				{/*    <Spin style={{*/}
				{/*        margin: "auto", width: "100%", paddingTop: "2em",*/}
				{/*        position: "absolute", left: 0, right: 0*/}
				{/*    }}/>*/}
				{/*)}*/}
				<div className={`main-body`}>
					{/* 타이틀 */}
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<h3 className={`body-title`}>
							가입한 회원수
							<span
								style={{
									color: "#117ffa",
									fontWeight: "bold",
									marginLeft: "3px",
								}}
							>
								{userCount?.toLocaleString()}
							</span>
						</h3>
						<Dropdown
							overlay={dropdownPageSize}
							trigger={["click"]}
							disabled={isLoading}
						>
							<Button
								style={{
									display: "flex",
									alignItems: "center",
									gap: "3px",
									fontSize: "1em",
									height: "auto",
								}}
								disabled={isLoading}
							>
								{pageSize}개씩
								<img
									src={`/assets/images/report/report-search-date-icon-down.png`}
									alt={`드롭다운`}
									style={{
										height: "auto",
										width: "0.8em",
									}}
								/>
							</Button>
						</Dropdown>
					</div>

					<Table
						dataSource={members}
						className="group-buying-table"
						rowKey={`id`}
						style={{ padding: "0.5em 0" }}
						columns={columns}
						pagination={false}
						loading={isLoading}
						showHeader={!mediaResult}
					/>
					<Pagination
						className="report-pagination-wrap"
						showSizeChanger={false}
						current={currentPageNumber}
						pageSize={pageSize}
						total={userCount}
						size={mediaResult ? "small" : "default"}
						onChange={handleChangePagination}
						disabled={isLoading}
					/>
				</div>
			</div>
		</div>
	);
};
export default UserManage;
